import { TALK_TO_SALES_PATH, BOOKING_CONFIRMED_PATH } from "./groupsPlan";

/**
 * The marketing / landing site (virtualscribe.ai) is served from a different
 * domain than this app. Anything that lives there (Talk to sales, Help center,
 * Terms, Privacy, ...) must be reached via an absolute URL, never via an
 * in-app router path.
 *
 * Override per environment with REACT_APP_PUBLIC_SITE_URL (e.g. in
 * FE/.env.local: REACT_APP_PUBLIC_SITE_URL=http://localhost:3001 when the
 * landing site runs locally). Never point this at the app's own origin —
 * the app itself is CRA on :3000 and the redirect routes would loop.
 */
export const PUBLIC_SITE_URL = (
  process.env.REACT_APP_PUBLIC_SITE_URL || "https://virtualscribe.ai"
).replace(/\/+$/, "");


/** True when PUBLIC_SITE_URL resolves to this app's own origin (misconfig). */
export const isPublicSiteSelf = () => {
  try {
    return new URL(PUBLIC_SITE_URL).origin === window.location.origin;
  } catch {
    return false;
  }
};

/** Build an absolute URL on the public site for a given path. */
export const publicSiteUrl = (path = "/") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_SITE_URL}${normalized}`;
};

export const TALK_TO_SALES_URL = publicSiteUrl(TALK_TO_SALES_PATH);
export const BOOKING_CONFIRMED_URL = publicSiteUrl(BOOKING_CONFIRMED_PATH);
export const HELP_CENTER_URL = publicSiteUrl("/help-center");
export const TERMS_OF_USE_URL = publicSiteUrl("/terms-of-use");
export const PRIVACY_POLICY_URL = publicSiteUrl("/privacy-policy");
export const PRICING_PATH = "/pricing";
export const PRICING_URL = publicSiteUrl(PRICING_PATH);

/**
 * Open a public-site page in a new tab so the user keeps their place in the
 * app (matches how Help center / Terms / Privacy already behave).
 * Falls back to same-tab navigation if the popup was blocked.
 */
export const openPublicSite = (url) => {
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

/** Open the Talk to sales page on the public site in a new tab. */
export const goToTalkToSales = () => {
  openPublicSite(TALK_TO_SALES_URL);
};

/** Open the pricing / compare-plans page on the public site in a new tab. */
export const goToPricing = () => {
  openPublicSite(PRICING_URL);
};
